import { render, staticRenderFns } from "./adminCategories.vue?vue&type=template&id=750bfc7b&scoped=true"
import script from "./adminCategories.vue?vue&type=script&lang=js"
export * from "./adminCategories.vue?vue&type=script&lang=js"
import style0 from "./adminCategories.vue?vue&type=style&index=0&id=750bfc7b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750bfc7b",
  null
  
)

export default component.exports